/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ProfileCompletionGuard } from './components/ProfileCompletionGuard';
import { useGlobalSlice } from './slice';
import { ThemeProvider } from './components/ui/theme-provider';
import { Toaster } from './components/ui/toaster';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { globalActions } from './slice';

import { Signin } from './pages/signin/Loadable';
import { ReturningSignin } from './pages/returning-signin/Loadable';
import { HelpCenterLayout } from './components/AdminLayout/HelpCenterLayout';
import { ReportIssue } from './pages/report-issue/Loadable';
import { Feedbacks } from './pages/feedbacks/Loadable';
import { OtherHelp } from './pages/other-help/Loadable';
import { AccountSettingsLayout } from './components/AdminLayout/AccountSettingsLayout';
import { UserProfile } from './pages/user-profile/Loadable';
import { PracticeInfo } from './pages/practice-info/Loadable';
import { ServicePlans } from './pages/service-plans/Loadable';
import { BillingHistory } from './pages/billing-history/Loadable';
import { Congrats } from './pages/service-plans/components/Congrats';
import { Timeout } from './components/common/Timeout';
import { NotFoundPage } from './pages/NotFoundPage';
import AppointmentListPage from './pages/appointment-copy/components/AppointmentListPage';
import Referral from './pages/referral-list';
import { InsightOverview } from './pages/insight-overview/Loadable';
import { ResetPassword } from './pages/ResetPassword';
// import { GlobalStyle } from 'styles/global-styles';

export function App() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  useGlobalSlice();
  const token = localStorage.getItem('api_token');
  const rememberMe = localStorage.getItem('rememberMe') === 'true';
  
  // Initialize authentication state on app load
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('api_token');
    const storedRememberMe = localStorage.getItem('rememberMe') === 'true';
    
    // If we have a token and rememberMe is true, restore the user state
    if (storedToken && storedRememberMe && storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        dispatch(globalActions.setUser(userData));
        dispatch(globalActions.setIsLogin(true));
      } catch (error) {
        console.error('Error parsing stored user data:', error);
        // Clear invalid data
        localStorage.removeItem('user');
        localStorage.removeItem('api_token');
        localStorage.removeItem('rememberMe');
      }
    }
  }, [dispatch]);
  
  return (
    <BrowserRouter>
      <ThemeProvider defaultTheme="light">
        <Helmet
          titleTemplate="%s - LOOP"
          defaultTitle="LOOP"
          htmlAttributes={{ lang: i18n.language }}
        >
          <meta name="description" content="LOOP" />
        </Helmet>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/signup" element={<Signin />} />
          <Route path="/login" element={
            token && rememberMe ? <Navigate to="/appointment-requests" replace /> : <ReturningSignin />
          } />
          <Route path="/auth/user/reset-password" element={<ResetPassword />} />
          <Route path="/account-settings/congrats" element={<Congrats />} />
          <Route path="/time-out" element={<Timeout />} />
          <Route element={<ProtectedRoute />}>
          { token&&rememberMe && <Route path="/appointment-requests" element={
              <ProfileCompletionGuard>
                <AppointmentListPage />
              </ProfileCompletionGuard>
            } />}
            <Route path="/appointment-requests" element={
              <ProfileCompletionGuard>
                <AppointmentListPage />
              </ProfileCompletionGuard>
            } />
            <Route path="/insight-overview" element={
              <ProfileCompletionGuard>
                <InsightOverview />
              </ProfileCompletionGuard>
            } />
            <Route element={<HelpCenterLayout />}>
							<Route
								path="/help-center/report-issue"
								element={<ReportIssue />}
							/>
							<Route
								path="/help-center/feedbacks"
								element={<Feedbacks />}
							/>
							<Route
								path="/help-center/other-help"
								element={<OtherHelp />}
							/>
						</Route>
            <Route element={<AccountSettingsLayout />}>
							<Route
								path="/account-settings/user-profile"
								element={<UserProfile />}
							/>
							<Route
								path="/account-settings/practice-info"
								element={<PracticeInfo />}
							/>
							<Route
								path="/account-settings/service-plans"
								element={<ServicePlans />}
							/>
							<Route
								path="/account-settings/billing-history"
								element={<BillingHistory />}
							/>
						</Route>
            <Route path="/logout" element={
              <div>
                <h1>Logout</h1>
              </div>
            } />
						<Route path="/provider-referrals" element={
              <ProfileCompletionGuard>
                <Referral />
              </ProfileCompletionGuard>
            } />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toaster />
        {/* <GlobalStyle /> */}
      </ThemeProvider>
    </BrowserRouter>
  );
}
